/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, origin: NonNullable<unknown> }} Agent_Run_StartedInputs */



/**
* | output |
* | --- |
* | "Started {time} · {origin}" |
*
* @param {Agent_Run_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_started = /** @type {((inputs: Agent_Run_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gestartet ${i?.time} · ${i?.origin}`)
	return /** @type {LocalizedString} */ (`Started ${i?.time} · ${i?.origin}`)
});